import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminOrdersTranslation } from "../../translations";

const OrderHeader = ({ orderId, orderNumber, onBackClick, onInvoiceClick }) => {
    const { language } = useLanguage();
    const { t } = useAdminOrdersTranslation(language);

    const displayOrderNumber = orderNumber ? `#${orderNumber}` : `#${orderId}`;

    return (
        <div className="order-details-header">
            <h1>{t('orderDetails')} {displayOrderNumber}</h1>
            <div className="order-actions">
                <button className="back-button" onClick={onBackClick}>
                    {t('backToOrders')}
                </button>
                <button className="invoice-button" onClick={onInvoiceClick}>
                    {t('invoice')}
                </button>
            </div>
        </div>
    );
};

export default OrderHeader;